import React from 'react';
import {convertorSubCardType} from './uitilities';

interface SubCardSwitcherProps {
  post: ICardData;
  subtype: string;
  homeCards?: boolean;
}
const SubCardSwitcher = ({post, subtype, homeCards}: SubCardSwitcherProps) => {
  return <>{convertorSubCardType[subtype](post, homeCards)}</>;
};

export default SubCardSwitcher;
